export enum InitialFlowErrorType {
  noTenant = 'noTenant',
  noRole = 'noRole',
  noDictionary = 'noDictionary',
  noAccount = 'noAccount',
  noTenantRole = 'noTenantRole',
  noSettings = 'noSettings',
}
